import $axios from "../api/accessor";
import { $api } from "../api/api";

export const PortfolioService = {
  async getAllPortfolio() {
    let response = await $axios.get($api("get_portfolios")).catch((err) => {
      return err.response;
    });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getLastedPortfolio() {
    let response = await $axios.get($api("lasted_portfolios")).catch((err) => {
      return err.response;
    });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getAllPortfolioDetail(id: any) {
    let response = await $axios
      .get($api("get_portfoliosDetail", { id }))
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
